import React, { useEffect } from 'react';

import { clsx } from 'clsx';

import { SecondaryPlanetType } from 'src/types';

import { AnimationControls, motion } from 'framer-motion';

import styles from './intro.scss';

export const SecondaryPlanet = (props: {
  isAnimating: boolean;
  planet: SecondaryPlanetType;
  isMobile: boolean;
  direction: boolean | null;
  control: AnimationControls;
}) => {
  const parallax = (e): void => {
    const planets: NodeListOf<HTMLImageElement> = document.querySelectorAll('#animatedPlanet');

    planets.forEach((planet) => {
      const speed: number = parseInt(planet.getAttribute('data-speed')!, 10);

      if (typeof window !== 'undefined') {
        const x = (window.innerWidth - e.pageX * speed) / 100;
        const y = (window.innerHeight - e.pageY * speed) / 100;

        planet.style.transform =
          planet.alt == 'mainPlanet'
            ? `translateX(calc(-50% + ${x}px)) translateY(calc(-50% + ${y}px))`
            : `translateX(${x}px) translateY(${y}px)`;
        planet.style.transition = 'all 0.15s';
      }
    });
  };

  useEffect(() => {
    if (!props.isAnimating) {
      document.addEventListener('mousemove', parallax);
    }

    return () => {
      document.removeEventListener('mousemove', parallax);
    };
  }, [props.isAnimating]);

  const planetSize = props.isMobile ? props.planet.mobileSize : props.planet.size;
  const planetOpacity = 1;

  const planetVariants = {
    initial: {
      opacity: 0,
      display: 'none',
      x: props.planet.direction * 50,
      y: -1 * props.planet.direction * 50,
      transition: {
        duration: 0.5,
        delay: 0.5,
        display: {
          delay: 1,
        },
      },
    },
    animate: {
      opacity: planetOpacity,
      display: 'block',
      x: 0,
      y: 0,
      transition: {
        delay: 2,
        duration: 0.5,
      },
    },
  };

  return (
    <motion.img
      src={props.planet.src}
      id="animatedPlanet"
      data-speed={props.planet.speed}
      key={props.planet.id}
      alt="planet"
      className={clsx(styles.secondaryPlanets, styles[`planet${props.planet.id}`])}
      style={{
        height: planetSize + 'px',
        width: planetSize + 'px',
      }}
      variants={planetVariants}
      initial="initial"
      animate={props.control}
    />
  );
};
